/**
 * Mentoros Dashboard - Version Constants
 * 
 * Central location for Dashboard versioning.
 * This file is used to send version headers to the Backend.
 */

/**
 * Dashboard Version Configuration
 */
export const DASHBOARD_VERSION = {
  /** Current Dashboard version (SemVer) */
  version: '1.0.0',
  
  /** Dashboard name */
  name: 'mentoros-merchant-dashboard',
  
  /** Minimum Backend version compatible with this Dashboard */
  minBackendVersion: '1.0.0',
} as const;

/**
 * HTTP headers for version identification
 */
export const VERSION_HEADERS = {
  /** Header name for Dashboard version */
  dashboardVersion: 'X-Dashboard-Version',
} as const;

/**
 * Get version info object for debugging
 */
export function getVersionInfo(): {
  dashboard: { name: string; version: string };
  compatibility: { minBackendVersion: string };
} {
  return {
    dashboard: {
      name: DASHBOARD_VERSION.name,
      version: DASHBOARD_VERSION.version,
    },
    compatibility: {
      minBackendVersion: DASHBOARD_VERSION.minBackendVersion,
    },
  };
}
